// Swedish public holidays ("röda dagar") — computed, not hardcoded, so the
// calendar stays correct in any year without a yearly data update. Purely
// client-side date arithmetic, no external calendar API/service involved.

const addDays = (date, n) => {
  const d = new Date(date)
  d.setDate(d.getDate() + n)
  return d
}

// First Saturday on/after `date` — used for the two holidays defined as
// "the Saturday that falls in [a given week]" (Midsommardagen, Alla helgons dag).
const firstSaturdayOnOrAfter = (date) => {
  const d = new Date(date)
  d.setDate(d.getDate() + ((6 - d.getDay() + 7) % 7))
  return d
}

// Easter Sunday (Gregorian) via the Meeus/Jones/Butcher algorithm — every
// other movable holiday below is defined relative to this date.
const easterSunday = (year) => {
  const a = year % 19
  const b = Math.floor(year / 100)
  const c = year % 100
  const d = Math.floor(b / 4)
  const e = b % 4
  const f = Math.floor((b + 8) / 25)
  const g = Math.floor((b - f + 1) / 3)
  const h = (19 * a + b - d - g + 15) % 30
  const i = Math.floor(c / 4)
  const k = c % 4
  const l = (32 + 2 * e + 2 * i - h - k) % 7
  const m = Math.floor((a + 11 * h + 22 * l) / 451)
  const month = Math.floor((h + l - 7 * m + 114) / 31)
  const day = ((h + l - 7 * m + 114) % 31) + 1
  return new Date(year, month - 1, day)
}

const holidaysByYear = {}

const computeHolidays = (year) => {
  const easter = easterSunday(year)
  const midsommardagen = firstSaturdayOnOrAfter(new Date(year, 5, 20))
  return [
    { date: new Date(year, 0, 1),  name: 'Nyårsdagen' },
    { date: new Date(year, 0, 6),  name: 'Trettondedag jul' },
    { date: addDays(easter, -2),   name: 'Långfredagen' },
    { date: easter,                name: 'Påskdagen' },
    { date: addDays(easter, 1),    name: 'Annandag påsk' },
    { date: new Date(year, 4, 1),  name: 'Första maj' },
    { date: addDays(easter, 39),   name: 'Kristi himmelsfärdsdag' },
    { date: addDays(easter, 49),   name: 'Pingstdagen' },
    { date: new Date(year, 5, 6),  name: 'Sveriges nationaldag' },
    // Not official public holidays, but widely treated as non-working days
    // in Sweden, so they get the same red marking.
    { date: addDays(midsommardagen, -1), name: 'Midsommarafton' },
    { date: midsommardagen,        name: 'Midsommardagen' },
    { date: firstSaturdayOnOrAfter(new Date(year, 9, 31)), name: 'Alla helgons dag' },
    { date: new Date(year, 11, 24), name: 'Julafton' },
    { date: new Date(year, 11, 25), name: 'Juldagen' },
    { date: new Date(year, 11, 26), name: 'Annandag jul' },
    { date: new Date(year, 11, 31), name: 'Nyårsafton' },
  ]
}

const getHolidaysForYear = (year) => {
  if (!holidaysByYear[year]) holidaysByYear[year] = computeHolidays(year)
  return holidaysByYear[year]
}

const isSameDay = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()

// Returns the holiday name if `date` is a Swedish public holiday, else null.
export const swedishHolidayName = (date) => {
  const hit = getHolidaysForYear(date.getFullYear()).find(h => isSameDay(h.date, date))
  return hit ? hit.name : null
}

export const isWeekendDay = (date) => {
  const day = date.getDay()
  return day === 0 || day === 6
}
